import {Injectable} from '@angular/core';
import {HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {ImageDialogComponent} from "../../modules/shared/components/image-dialog/image-dialog.component";

@Injectable()
export class NoConnInterceptor implements HttpInterceptor {
  private isDialogOpen = false;

  constructor(private dialog: MatDialog) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if ((!navigator.onLine || error.status === 0) && !this.isDialogOpen) {
          this.isDialogOpen = true;

          const dialogRef = this.dialog.open(ImageDialogComponent, {
            width: '400px',
            disableClose: true,
            data: {
              message: 'NO_INTERNET_MESSAGE',
              title: 'NO_INTERNET_TITLE',
              img: 'assets/imgs/coming-soon.webp'
            }
          });

          // Reset flag when dialog is closed
          dialogRef.afterClosed().subscribe(() => {
            this.isDialogOpen = false;
          });
        }
        return throwError(() => error);
      })
    );
  }
}
